import React from "react"

import Carousel from "decentraland-gatsby/dist/components/Carousel/Carousel"
import ImgFixed from "decentraland-gatsby/dist/components/Image/ImgFixed"
import Paragraph from "decentraland-gatsby/dist/components/Text/Paragraph"
import SubTitle from "decentraland-gatsby/dist/components/Text/SubTitle"
import TokenList from "decentraland-gatsby/dist/utils/dom/TokenList"
import { Button } from "decentraland-ui/dist/components/Button/Button"

import jumpIn from "../../images/jump-in.svg"
import { FeedProps } from "./types"
import { ellipsis, useFeedColumnName } from "./utils"

export type Scene = {
  name: string
  description: string
  position: [number, number]
  target?: string
  image?: string
}

export type ScenesFeedProps = FeedProps & {
  scenes: Scene[]
}

const DEFAULT_COLUMNS = 4

export default function ScenesFeed({ scenes, columns }: ScenesFeedProps) {
  const columnClassName = useFeedColumnName(columns, DEFAULT_COLUMNS)
  return (
    <Carousel className="ScenesFeed">
      {scenes.map((scene, i) => {
        const position = scene.position || [0, 0]
        const target =
          scene.target ||
          `https://play.decentraland.org/?position=${position.join(",")}`
        const image =
          scene.image ||
          `https://api.decentraland.org/v1/parcels/${position.join(
            "/"
          )}/map.png`

        return (
          <a
            key={`scene::${i}`}
            className={TokenList.join(["Feed__Item", columnClassName])}
            href={target}
            target="_blank"
          >
            <div className="Feed__Item__Background" />
            <ImgFixed dimension="square" src={image} background="black" />
            <div className="Feed__Item__Detail animated">
              <div className="Feed__Item__TitleContainer">
                <SubTitle>{ellipsis(scene.name, 65)}</SubTitle>
                <Paragraph>{ellipsis(scene.description, 85)}</Paragraph>
              </div>
              <div className="Feed__Item__ActionContainer">
                <Button primary size="small">
                  JUMP IN{" "}
                  <img
                    src={jumpIn}
                    width="16"
                    height="16"
                    className="JumpInIcon"
                  />
                </Button>
              </div>
            </div>
          </a>
        )
      })}
    </Carousel>
  )
}

ScenesFeed.defaultProps = {
  columns: 4,
}
